import React from 'react';

import { useExportMapByTypeSvg } from '../Components/Images/ExportMapByTypeSvg';
import { useExportMapPlanSvg } from '../Components/Images/ExportMapPlanSvg';
import { useExportMapBandsFromBandIdStudio } from '../Components/Images/Laizes/ExportMapBands/LaizeExportBandsFromBandIdStudio';
import { useExportMapBandsInRoomStudio } from '../Components/Images/Laizes/ExportMapBands/LaizeExportBandsInRoomStudio';
import { ExportBandsFromBandId, ExportBandsInRoom } from '../Components/Images/Laizes/LaizeExportBands';
import { RoomType } from '../Models/IRoom';
import { useMapContextState } from './MapContext';
import { styled } from '@material-ui/core';

export type MapExportContextValue = {
    captureByTypeSvg: (type: RoomType) => string;
    captureByTypePng: (type: RoomType) => Promise<string>;
    capturePlanSvg: () => string;
    capturePlanPng: () => Promise<string>;
    exportBandsInRoom: ExportBandsInRoom[];
    exportBandsFromBandId: ExportBandsFromBandId[];
};
const MapExportContext = React.createContext<MapExportContextValue>({
    captureByTypeSvg: () => '',
    captureByTypePng: () => Promise.resolve(''),
    capturePlanSvg: () => '',
    capturePlanPng: () => Promise.resolve(''),
    exportBandsInRoom: [],
    exportBandsFromBandId: [],
});

export const useMapExport = () => React.useContext(MapExportContext);

export const MapExportProvider: React.FC = ({ children }) => {
    const mapState = useMapContextState() ?? { rooms: [] };
    const { mapByTypeView, captureByTypePng, captureByTypeSvg } = useExportMapByTypeSvg({ mapState });
    const { mapPlanView, capturePlanSvg, capturePlanPng } = useExportMapPlanSvg({ mapState });
    const { exportItems: exportBandsInRoom } = useExportMapBandsInRoomStudio(mapState);
    const { exportItems: exportBandsFromBandId } = useExportMapBandsFromBandIdStudio(mapState);

    return (
        <MapExportContext.Provider
            value={{
                captureByTypeSvg,
                captureByTypePng,
                capturePlanSvg,
                capturePlanPng,
                exportBandsInRoom,
                exportBandsFromBandId,
            }}>
            {children}
            {mapPlanView()}
            {mapByTypeView(RoomType.Sol)}
            {mapByTypeView(RoomType.Wall)}
            <SvgContainer id="BandsInRoom">
                {exportBandsInRoom.map((item) => item.renderView({ id: item.room.roomId }))}
            </SvgContainer>
            <SvgContainer id="BandsFromBandId">
                {exportBandsFromBandId.map((item) => item.renderView({ id: item.bandFileName }))}
            </SvgContainer>
        </MapExportContext.Provider>
    );
};

const SvgContainer = styled('div')({ display: 'none' });
